"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = exports.TreeView = exports.isTreeNode = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var TreeNode_1 = require("./TreeNode");
var checktree_1 = require("../../checktree");
var TreeContext_1 = require("./TreeContext");
var use_default_1 = require("../../_util/use-default");
var is_child_of_type_1 = require("../../_util/is-child-of-type");
var config_context_1 = require("../../_util/config-context");
var warn_1 = require("../../_util/warn");
/**
 * CheckTree 转换
 *
 * 叶节点 -> 全部选中节点
 */
function getAllIds(selectedIds, relations, childrenMap) {
    var e_1, _a, e_2, _b;
    var nodes = tslib_1.__spread(selectedIds);
    try {
        // 插入缺失的父节点
        for (var nodes_1 = tslib_1.__values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var id = nodes_1_1.value;
            var pid = relations[id];
            var childrenSet = childrenMap.get(pid);
            // 加入子节点全部选中的父节点
            if (pid &&
                childrenSet &&
                !nodes.includes(pid) &&
                !tslib_1.__spread(childrenSet).find(function (cid) { return !nodes.includes(cid); })) {
                nodes.push(pid);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        // 插入缺失的子节点
        for (var nodes_2 = tslib_1.__values(nodes), nodes_2_1 = nodes_2.next(); !nodes_2_1.done; nodes_2_1 = nodes_2.next()) {
            var id = nodes_2_1.value;
            var children = tslib_1.__spread((childrenMap.get(id) || []));
            children.forEach(function (cid) {
                if (!nodes.includes(cid)) {
                    nodes.push(cid);
                }
            });
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (nodes_2_1 && !nodes_2_1.done && (_b = nodes_2.return)) _b.call(nodes_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return nodes;
}
/**
 * CheckTree 转换
 *
 * 全部选中节点 -> 叶节点
 */
function getLeafIds(selectedIds, relations, childrenMap) {
    var all = getAllIds(selectedIds, relations, childrenMap);
    var nodes = [];
    all.forEach(function (id) {
        if (!childrenMap.get(id)) {
            nodes.push(id);
        }
    });
    return nodes;
}
function isTreeNode(node) {
    return is_child_of_type_1.isChildOfType(node, TreeNode_1.TreeNode);
}
exports.isTreeNode = isTreeNode;
/**
 * 遍历子节点
 */
function traverse(rootId, children, tree) {
    if (!children) {
        return;
    }
    var relations = tree.relations, childrenMap = tree.childrenMap, disabledIds = tree.disabledIds;
    react_1.default.Children.forEach(children, function (child) {
        if (isTreeNode(child) ||
            (react_1.default.isValidElement(child) && typeof child.props.id !== "undefined")) {
            var _a = child.props, id = _a.id, selectable = _a.selectable, disableSelect = _a.disableSelect;
            if (selectable !== false) {
                // 非最外层根
                if (rootId) {
                    relations[id] = rootId;
                    if (!childrenMap.has(rootId)) {
                        childrenMap.set(rootId, new Set());
                    }
                    childrenMap.get(rootId).add(id);
                }
                // 禁用
                if (disableSelect) {
                    disabledIds.push(id);
                }
            }
            // 当前结点不可选时其子结点 rootId 为当前 rootId
            traverse(selectable !== false ? id : rootId, child.props.children, tree);
        }
        else if (react_1.default.isValidElement(child)) {
            // eslint-disable-next-line dot-notation
            traverse(rootId, child.props["children"], tree);
        }
    });
}
/**
 * 构造树节点
 */
function renderTreeNodes(data) {
    return data.map(function (_a) {
        var children = _a.children, id = _a.id, props = tslib_1.__rest(_a, ["children", "id"]);
        if (children && children.length > 0) {
            return (react_1.default.createElement(TreeNode_1.TreeNode, tslib_1.__assign({ key: id, id: id }, props), renderTreeNodes(children)));
        }
        return react_1.default.createElement(TreeNode_1.TreeNode, tslib_1.__assign({ key: id, id: id }, props));
    });
}
exports.TreeView = react_1.default.forwardRef(function TreeView(_a, ref) {
    var _b;
    var selectable = _a.selectable, selectStrictly = _a.selectStrictly, selectedIds = _a.selectedIds, _c = _a.defaultSelectedIds, defaultSelectedIds = _c === void 0 ? [] : _c, onSelect = _a.onSelect, activable = _a.activable, activeIds = _a.activeIds, _d = _a.defaultActiveIds, defaultActiveIds = _d === void 0 ? [] : _d, onActive = _a.onActive, expandedIds = _a.expandedIds, _e = _a.defaultExpandedIds, defaultExpandedIds = _e === void 0 ? [] : _e, _f = _a.onExpand, onExpand = _f === void 0 ? function () { return null; } : _f, fullExpandable = _a.fullExpandable, onLoad = _a.onLoad, onLoadError = _a.onLoadError, switcherIcon = _a.switcherIcon, className = _a.className, children = _a.children, props = tslib_1.__rest(_a, ["selectable", "selectStrictly", "selectedIds", "defaultSelectedIds", "onSelect", "activable", "activeIds", "defaultActiveIds", "onActive", "expandedIds", "defaultExpandedIds", "onExpand", "fullExpandable", "onLoad", "onLoadError", "switcherIcon", "className", "children"]);
    // 开启选择时内容区不能用于展开
    if (selectable) {
        // eslint-disable-next-line no-param-reassign
        fullExpandable = false;
    }
    var classPrefix = config_context_1.useConfig().classPrefix;
    var childrenMap = react_1.useRef(new Map());
    var _g = tslib_1.__read(react_1.useState({}), 2), relations = _g[0], setRelations = _g[1];
    var _h = tslib_1.__read(react_1.useState([]), 2), disabledIds = _h[0], setDisabledIds = _h[1];
    var _j = tslib_1.__read(use_default_1.useDefault(selectedIds, defaultSelectedIds, onSelect), 2), selectedNodes = _j[0], setSelectedNodes = _j[1];
    var _k = tslib_1.__read(use_default_1.useDefault(activeIds, defaultActiveIds, onActive), 2), activeNodes = _k[0], setActiveNodes = _k[1];
    var _l = tslib_1.__read(use_default_1.useDefault(expandedIds, defaultExpandedIds, onExpand), 2), expandedNodes = _l[0], setExpandedNodes = _l[1];
    react_1.useEffect(function () {
        childrenMap.current = new Map();
        if (selectable) {
            var disabledIds_1 = [];
            if (!selectStrictly) {
                var relations_1 = {};
                traverse(undefined, children, {
                    relations: relations_1,
                    childrenMap: childrenMap.current,
                    disabledIds: disabledIds_1,
                });
                setRelations(relations_1);
            }
            else {
                traverse(undefined, children, {
                    relations: {},
                    childrenMap: new Map(),
                    disabledIds: disabledIds_1,
                });
            }
            setDisabledIds(disabledIds_1);
        }
    }, [children, selectStrictly, selectable]);
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-tree", className, (_b = {},
            _b[classPrefix + "-tree--checkbox-separate"] = selectable && activable,
            _b[classPrefix + "-tree--full-line"] = fullExpandable,
            _b)) }, props),
        react_1.default.createElement(TreeContext_1.TreeContext.Provider, { value: {
                selectable: selectable,
                activable: activable,
                activeIds: activeNodes,
                expandedIds: expandedNodes,
                onActive: function (activeId) {
                    return setActiveNodes([activeId], { active: true, nodeId: activeId });
                },
                onExpand: function (nodeId, expanded) {
                    return setExpandedNodes(expanded
                        ? tslib_1.__spread(expandedNodes, [nodeId]) : expandedNodes.filter(function (id) { return id !== nodeId; }), { nodeId: nodeId, expanded: expanded });
                },
                onLoad: onLoad,
                onLoadError: onLoadError,
                switcherIcon: switcherIcon,
                fullExpandable: fullExpandable,
            } },
            react_1.default.createElement("ul", null, selectable ? (react_1.default.createElement(checktree_1.CheckTree, { relations: relations, value: getLeafIds(selectedNodes, relations, childrenMap.current), onChange: function (value, _a) {
                    var check = _a.check;
                    return setSelectedNodes(getAllIds(value, relations, childrenMap.current), { nodeId: check.name, selected: check.value });
                }, disabledNames: disabledIds }, children)) : (children)))));
});
exports.TreeView.displayName = "TreeView";
exports.Tree = react_1.forwardRef(function Tree(_a, ref) {
    var data = _a.data, children = _a.children, props = tslib_1.__rest(_a, ["data", "children"]);
    react_1.useEffect(function () {
        warn_1.warn("请不要在 Tree 内嵌套使用自定义组件，该用法将在后续版本中被废弃。");
    }, []);
    return (react_1.default.createElement(exports.TreeView, tslib_1.__assign({ ref: ref }, props), children));
});
exports.Tree.displayName = "Tree";
//# sourceMappingURL=Tree.js.map